import * as z from "zod";

export const getUpdatedSavedEmailTemplates = {
  name: "getUpdatedSavedEmailTemplates" as const,
  input: z.object({ lastCheckedDate: z.coerce.date() }),
  output: z.object({ updatedTemplateIds: z.array(z.string()) }),
};
